import { Box, Typography } from '@mui/material';
import * as React from 'react';
import {
  Question,
  QuestionFormResponse,
} from '../../questionnaire/types/questionnaire.types';
import { ResponseDisplay } from './ResponseDisplay';

interface QuestionViewerProps {
  question: Question;
  questionNumber: number;
  response: QuestionFormResponse | undefined;
}

export const QuestionViewer: React.FC<QuestionViewerProps> = ({
  question,
  questionNumber,
  response,
}) => {
  const hasResponse = !!response;

  return (
    <Box
      sx={{
        mb: 3,
        p: 3,
        borderRadius: '16px',
        border: '1px solid #e5e7eb',
        background: '#ffffff',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, mb: 2 }}>
        <Typography
          sx={{
            border: `3px solid ${hasResponse ? '#7854AB' : '#667eea'}`,
            textAlign: 'center',
            color: hasResponse ? '#7854AB' : '#667eea',
            borderRadius: '50%',
            height: '40px !important',
            width: '40px !important',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: 'Roboto-Bold !important',
            fontSize: '16pt !important',
            flexShrink: 0,
          }}
        >
          {questionNumber}
        </Typography>
        {/* <Typography
          sx={{
            fontFamily: 'Roboto-Medium !important',
            fontSize: '12pt !important',
            color: '#374151 !important',
            lineHeight: 1.6,
          }}
        >
          {question.question}
          {question.required && (
            <span style={{ color: '#ef4444', marginLeft: '6px' }}>*</span>
          )}
        </Typography> */}
        {/* <Typography
          sx={{
            fontFamily: 'Roboto-Medium !important',
            fontSize: '12pt !important',
            color: '#374151 !important',
            lineHeight: 1.6,
          }}
          dangerouslySetInnerHTML={{
            __html:
              question.question +
              (question.required
                ? '<span style="color:#ef4444;margin-left:6px">*</span>'
                : ''),
          }}
        /> */}
        <Typography
          component="div"
          sx={{
            fontFamily: 'Roboto-Medium !important',
            fontSize: '12pt !important',
            color: '#374151 !important',
            lineHeight: 1.6,
            '& ul': {
              listStyleType: 'disc',
              paddingLeft: '1.5rem',
              marginTop: '0.5rem',
              marginBottom: '0.5rem',
            },
            '& ol': {
              listStyleType: 'decimal',
              paddingLeft: '1.5rem',
            },
            '& li': {
              display: 'list-item',
              marginBottom: '0.25rem',
            },
          }}
          dangerouslySetInnerHTML={{
            __html:
              question.question +
              (question.required
                ? '<span style="color:#ef4444;margin-left:6px">*</span>'
                : ''),
          }}
        />
      </Box>

      <ResponseDisplay question={question} response={response} />
    </Box>
  );
};
